<div class="d-flex align-items-center">
    <button mat-flat-button class="custom-button-volver" (click)="goBack()">
        <mat-icon aria-hidden="false" aria-label="Volver" fontIcon="arrow_back" class="icon-volver mr-3"></mat-icon>
        Volver
    </button>
</div>
<div class="container-fluid bg-white p-5 mb-5 br-10">
    <div class="d-flex justify-content-between">
        <h1>Detalles de la cartera</h1>
        <button
            mat-flat-button
            class="custom-button-secondary"
            type="button"
            (click)="onEdit()">
            <mat-icon class="mr-3">edit</mat-icon>
            Editar cartera
        </button>
    </div>

    <mat-card class="form-container simple-card mx-auto my-5">
        <mat-card-header>
            <mat-card-title class="font-size-title-card">
                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Detalles</strong>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="p-5">
            <div class="two-equal-columns-grid border p-5">
                <div class="grid">
                    <div class="fw-500">ID Cartera:</div>
                    <div>{{ detail?.id }}</div>

                    <div class="fw-500">Nombre Cartera:</div>
                    <div>{{ detail?.name }}</div>

                    <div class="fw-500">Cantidad de Ruts:</div>
                    <div>{{ detail?.countOfRuts }}</div>
                </div>

                <div class="grid">
                    <div class="fw-500">Fecha Creación:</div>
                    <div>{{ detail?.creationDate | date: 'dd-MM-yyyy HH:mm:ss' }}</div>

                    <div class="fw-500">Fecha Modificación:</div>
                    <div>{{ detail?.modificationDate | date: 'dd-MM-yyyy HH:mm:ss' }}</div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="simple-card mx-auto my-5">
        <mat-card-header class="d-flex justify-content-between pr-5">
            <mat-card-title class="font-size-title-card">
                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Procesos asignados</strong>
            </mat-card-title>
            <div>
                <button mat-flat-button class="custom-button-primary mr-3" type="button" (click)="onAdmin()">
                    <mat-icon class="mr-3">settings</mat-icon>
                    Administración procesos
                </button>

                <button mat-stroked-button color="primary" class="custom-stroke-button" type="button" (click)="onExecutions()">
                    Ver procesos ejecutados
                </button>
            </div>
        </mat-card-header>

        <mat-card-content class="p-5">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="modelo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por modelo">Modelo</th>
                        <td mat-cell *matCellDef="let element">{{ element?.batchTemplate?.name ? element?.batchTemplate?.name : element?.batchTemplate?.tag }}</td>
                    </ng-container>

                    <ng-container matColumnDef="frecuencia">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por frecuencia">Frecuencia</th>
                        <td mat-cell *matCellDef="let element">{{ element?.frequency?.description ? element?.frequency?.description : element?.frequency?.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="destino">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por destino">Destino</th>
                        <td mat-cell *matCellDef="let element">{{ element?.destination?.type }}</td>
                    </ng-container>

                    <ng-container matColumnDef="progress">
                        <th mat-cell *matCellDef="let element"></th>
                        <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                            <mat-progress-bar *ngIf="isBatchConfigListLoading" mode="indeterminate"></mat-progress-bar>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                        class="cursor-pointer"
                        (click)="goToExecutions(row)">
                    </tr>

                    <ng-container *ngIf="!isBatchConfigListLoading">
                        <tr class="mat-mdc-row" *matNoDataRow>
                            <td class="mat-mdc-cell text-center font-weight-500 loading-cell" [attr.colspan]="displayedColumns.length">
                                No hay datos disponibles
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
</div>